import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { StaffAchievementLiveComponent } from '../achievements/staff-achievement-live.component';
import { StaffWeightedWorkLiveComponent } from '../weighted-work/staff-weighted-work-live.component';
import { StaffWeightedWorkSearch } from '../../../../shared/models/staff-weighted-work.model';
import { STAFF_ACTIVE_BENCHMARKS_UPDATE_MESSAGE } from '../../../../shared/models/benchmark-policy.model';
import { defaultExcludedStaffIds, staffExclusionsMatch, STAFF_EXCLUSIONS_UPDATE_MESSAGE } from '../../../../shared/models/staff-exclusions.model';
import { StaffReportingCalendar, staffCalendarMatches, STAFF_CALENDAR_UPDATE_MESSAGE } from '../../../../shared/models/staff-reporting-calendar.model';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';
import { LegalDateTimeService } from 'src/app/services/legal-datetime.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');


@Component({
  selector: 'app-staff-performance-metrics-dashboard',
  templateUrl: './staff-performance-metrics-dashboard.component.html',
  styleUrls: ['./staff-performance-metrics-dashboard.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService]

})
export class StaffPerformanceMetricsDashboardComponent implements OnInit {
  @ViewChild(StaffWeightedWorkLiveComponent) weightedWork: StaffWeightedWorkLiveComponent;
  weightedSearch: StaffWeightedWorkSearch | null = null;
  @ViewChild(StaffAchievementLiveComponent) staffAchievement: StaffAchievementLiveComponent;
  readonly monthOptions = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  selectedCalendarYear = Number(this.legalDate.format(new Date(), 'YYYY'));
  activeMonthIndex: number | null = null;
  picker_when_from: Date | null = null;
  picker_when_to: Date | null = null;
  staffReportCalendar: StaffReportingCalendar | null = null;
  staffCalendarWarning = '';
  staffExclusionWarning = '';
  staffBenchmarkWarning = '';
  staffExclusionOptions: Array<{ user_id: number; user_full_name: string }> = [];
  private staffFilterGeneration = 0;

  onExcludedStaffChange(ids: Array<number | string> | null): void {
    this.search_model = { ...this.search_model, excluded_staff_ids: (ids || []).map(Number) };
    this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model);
  }

  restoreDefaultStaffExclusions(): void { this.onExcludedStaffChange(defaultExcludedStaffIds()); }

  onWeekendTargetsChange(includeWeekends: boolean): void {
    this.search_model = { ...this.search_model, include_weekends: includeWeekends };
    this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model);
  }

  get calendarYearOptions(): number[] {
    const currentYear = Number(this.legalDate.format(new Date(), 'YYYY'));
    const years: number[] = [];
    for (let year = currentYear; year >= Math.max(2020, currentYear - 8); year--) { years.push(year); }
    if (!years.includes(this.selectedCalendarYear)) { years.push(this.selectedCalendarYear); years.sort((a, b) => b - a); }
    return years;
  }

  setMonthWindow(monthIndex: number): void {
    if (!Number.isInteger(monthIndex) || monthIndex < 0 || monthIndex > 11) { return; }
    const from = new Date(this.selectedCalendarYear, monthIndex, 1, 0, 0, 0, 0);
    const to = new Date(this.selectedCalendarYear, monthIndex + 1, 0, 23, 59, 59, 999);
    // Keep actual instants in the shared search model. Picker values represent Brisbane wall time.
    this.search_model = { ...this.search_model,
      when_from: new Date(this.legalDate.fromPickerDate(from)),
      when_to: new Date(this.legalDate.fromPickerDate(to)) };
    this.syncCalendarSelection();
    this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model);
  }

  onCalendarYearChange(year: number | string): void {
    const numericYear = Number(year);
    if (!Number.isInteger(numericYear) || numericYear < 1900 || numericYear > 9999) { return; }
    this.selectedCalendarYear = numericYear;
    if (this.activeMonthIndex !== null) { this.setMonthWindow(this.activeMonthIndex); }
  }

  onStaffPickerChange(field: 'when_from' | 'when_to', value: Date | null): void {
    const iso = this.legalDate.fromPickerDate(value);
    this.search_model[field] = iso ? new Date(iso) : null;
    this.syncCalendarSelection();
  }

  syncCalendarSelection(): void {
    const from = this.legalDate.toPickerDate(this.search_model?.when_from);
    const to = this.legalDate.toPickerDate(this.search_model?.when_to);
    this.picker_when_from = from; this.picker_when_to = to;
    this.activeMonthIndex = null;
    if (!from || !to) { return; }
    this.selectedCalendarYear = from.getFullYear();
    const lastDate = new Date(from.getFullYear(), from.getMonth() + 1, 0).getDate();
    if (from.getDate() === 1 && from.getHours() === 0 && from.getMinutes() === 0 && from.getSeconds() === 0 && from.getMilliseconds() === 0
      && to.getFullYear() === from.getFullYear() && to.getMonth() === from.getMonth() && to.getDate() === lastDate
      && to.getHours() === 23 && to.getMinutes() === 59 && to.getSeconds() === 59) { this.activeMonthIndex = from.getMonth(); }
  }


  @Input() sent_data?: any; // not used

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid2') public grid2: GridComponent;
  @ViewChild('grid3') public grid3: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;

  public groupOptions: GroupSettingsModel;
  // public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;


  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both



     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full

       // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;


  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  // today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  myob_tax_codes_live: Object;
  myob_tax_codes: Object;
  created_myob_tax_account: Object;
  updated_myob_tax_account: Object;
  sessionUserName: string;
  sessionUserLevel: number;
  sessionUserFullName: string;
  sessionUserFirstName: string;
  action_lists: any;
  action_lists_table: any;
  action_list: any;
  action_list_removed: any;

  
  isShow: any;
  modalRef: any;

  // @Input() action_list_id?: Observable<any[]>; // impliments on changes.
  @Input() action_list_id?: any; // impliments on changes.
  search_results_meta: any;

  search_results_meta_array: any[];
  WebHookAPI_OrderLabelCreateDefaultBulk_response: any;
  action_list_type_id: number;


  woo_page: number; 
request_query: {
      context?: string;
      page?: number;
      per_page?: number;
      search?: string;
      after?: string;
      before?: string;
      exclude?: Array<any>;
      include?: Array<any>;
      offset?: number;
      // order?: ProductOrder;
      // orderby?: ProductOrderBy | string;
      orderby?: any;
    
      parent?: Array<string>;
      parent_exclude?: Array<string>;
      slug?: string;
      status?: string;
      type?: string;
      sku?: string;
      featured?: boolean;
      category?: string;
      tag?: string;
      shipping_class?: string;
      attribute?: string;
      attribute_term?: string;
      tax_class?: string;
      in_stock?: boolean;
      on_sale?: boolean;
      min_price?: string;
      max_price?: string;
      post__in?;
      action_list_id?;
      log_id_array?;
  }

  public page_collection = [];
  woo_orders: any;

  @Output('refreshChildGrid') refreshChildGrid:EventEmitter<any> 
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  woo_per_page: number;


  urlSafe: SafeResourceUrl;
  interval;
  productSlug: string;
  params: object = {}
  woo_ppsactions: any;
  woo_ppsactions_count: any;
  woo_ppsactionsBulkLabels: any;
  woo_ppsactions_count_bulk_labels: any;
  woo_ppsactionsPickList: any;
  woo_ppsactions_count_picklist: any;
  DialogObj: any;
  woo_orders_update: any;
  woo_orders__update_count: any;
  WebHookAPI_PickPackSend_WC_page_update_response: Object;
  WebHookAPI_PickPackSend_WC_page_update_status_response: Object;



  combo_model: Brand;
  search_model: SystemLog & { include_weekends?: boolean; excluded_staff_ids?: Array<number | string> };
  brands_client: any;
  brands_agent: any;
  users: any;
  brand_types: any;
  user_levels: any;
  system_log_types: any;
  model: any;
  sent_model: ppsDistrHubActionList;
  selectedrecords: object[];

  today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison

  chosenActionListID: any;
  get_latest_action_ist_id: any;
  action_list_today: Object;
  action_list_today_ID: any;
  logs_search: any;
  search_results_meta_START: any[];
log_types_kpi_array: any;
count_logs_search: number;
count_log_type_kpi_1: any;
log_type_kpi_5_count: any;
log_type_kpi_5_array: any;
log_type_kpi_array_30: any[];
count_log_type_kpi_array_30: number;
log_type_kpi_array_metric_table: any[];
count_log_type_kpi_array_5: any;
log_types_selected_kpi_array: any[];
duration_seconds: number;
duration_minutes: number;
duration_hours: number;
search_model_duration_array: any[];
log_type_kpi_array_6: any[];
count_log_type_kpi_array_6: number;
log_type_kpi_array_13: any[];
count_log_type_kpi_array_13: number;
logs_search_kPI_benchmarks_global: any;
count_logs_search_kPI_benchmarks_global: number;
logs_search_kPI_benchmarks_global_GRID: any;
logs_search_kPI_benchmarks_global_GRID_count: any;

  created_by_count_array_data: any[];
  all_items_count_array_data: any[];
  all_items_count_array_data_count: number;
  log_type_id_group_staff: any[];
  log_types_selected_kpi_object: any;
  users_staff: any;
  public staff_fields: Object = { text: 'user_full_name', value: 'user_id' }; // Adjust field mapping as needed

  availableLogTypes: any;
  benchmark_kpi_group_log_type_array: Object;
  benchmark_kpi_group: Object;
  allLogTypesArray: any;
  dateInfo: { firstRecord: any; lastRecord: any; };
    // Need to create a different type of data service?
  // see: https://ej2.syncfusion.com/angular/documentation/grid/observables/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    this.service.execute(state);
  }

// ... additions for datepicker column for sycfusion grid
  //public data: Object[];
  //public ddldata: Object[];
  //public pageOptions: Object;
  public category: string[];
  //public templateOptionsDate: IFilterUI;
  //public elem1: HTMLElement;
  //public datePickerObj: DatePicker;

  // maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  search_results: any;

  public log_type_fields: Object = { text: 'log_type_name', value: 'log_type_id' }; // using the name field not id!


  // Mimucs the lower components counts
         // toggle elements
        //  isShow = true;
        isShow_chart1 = false;
        isShow_chart2 = true;
        isShow_chart3 = false;
        isShow_chart4 = false; // new staff metrics perspective.
        

         isShow_chart1_meta = false;
         isShow_chart2_meta = true;



         primaryXAxis: Object = {};
         chartData: any;
         title: string = "";
         pointColorMapping = "";
         public legendSettings = {};



  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public service: DataService,
     public legalDate: LegalDateTimeService,
    //  private orderService: WoocommerceOrderService,
     public sanitizer: DomSanitizer, // https://stackblitz.com/edit/angular-iframe-src-ae7kkf?file=src%2Fapp%2Fapp.component.ts
    //  private woocommerce: WordpressService, 
  ) {   

    // Set and Access login Session Variables
    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

          // So set session vars manually. PPS Distro Hub - No Loging Required
          // this.sessionUserId = 142;
          // this.sessionUsername = 'temperosystems';
          // this.sessionUserName = 'temperosystems';
          // this.sessionBrandId = 125;
          // this.sessionUserLevel = 1000;
          // this.sessionUserFullName = 'tempero user';
          // this.sessionUserFirstName = 'tempero';    
    
        // need to add this as routes does not work globally
        this.all_router_details = this.router.url;
        this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
       
       // this.action_list_id = +this.route.snapshot.paramMap.get('action_list_id');
    

          // Grid Options
          // this.toolbarOptions = [];
          // Setup Grid
          // this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
          // tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
          // ];
          // this.toolbar = [
          // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

          this.toolbarOptions = ['Search'];

          this.initialPage = { pageSize: 2500 };
          this.filterOptions = {
          type: 'Menu'
          };

          // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
          this.groupOptions = { }; // sets auto grouping for the grid

          this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
          this.dateFormat = 'dd/MM/yyyy hh:mm a';
          // this.filter = { params: { format: this.dateFormat } };
          // this.sortOptions = { columns: [ ] };

          //checkbox selection options
          // this.selectionOptions = { checkboxMode: 'ResetOnRowClick'}; // type: 'Multiple', mode: 'Both
          // this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 
          // this.selectionOptions = { }; // 


          this.searchOptions = {  };
          // this.grid.searchSettings.key = '';
          this.wrapSettings = { wrapMode: 'Content' };

    

          // c3 charts setup testing



          // new chars

          this.primaryXAxis = {
            valueType: "Category",
            title: "Activies",
            visible: true
          };
          this.title = "Staff Activites By";
          this.chartData = [
            { country: "USA", gold: 50, color: "red" },
            { country: "China", gold: 40, color: "black" },
            { country: "Japan", gold: 70, color: "yellow" },
            { country: "Australia", gold: 60, color: "purple" },
            { country: "France", gold: 50, color: "orange" },
            { country: "Germany", gold: 40, color: "red" },
            { country: "Italy", gold: 40, color: "brown" },
            { country: "Sweden", gold: 30, color: "blue" }
          ];
          this.pointColorMapping = "color";
          this.legendSettings = { visible: true, position: "Right" };

          
     
       }
    
       // check for changes. to load data.
       ngOnChanges(changes) {

        this.woo_page = 1; // sets the default page to load is one
        this.woo_per_page = 100;
      
        if(this.woo_page == 1){
          this.request_query = {
            // page: this.woo_page + 1,
            page: this.woo_page,
            orderby: "id",
            per_page: this.woo_per_page,
            // per_page: 10 // gets the number of rec
            }; 
        }else{
          this.request_query = {
            page: this.woo_page,
            orderby: "id",
            per_page: this.woo_per_page,
            // per_page: 10 // gets the number of rec
            }; 
        }

        // Load the Actions related to the action list
// this.getWooPPSActionsMetaActionID('', this.action_list_id, '38' ); // Bulk Prints Only

/// dont know if this is required or not?
                    // if(!this.action_list_id || this.action_list == '' ){
                    //   this.action_list_id = +this.route.snapshot.paramMap.get('action_list_id');
                    // }
            
                    // if (changes.item_id) {
                    //   // deal with asynchronous Observable result
                    //   this.item_id = changes.item_id.currentValue;
                    // }
            
            
                    // if (changes.action_list_id) {
                    //   // deal with asynchronous Observable result
                    //   // this.getJob(this.job_id);
                    // console.log('On changes Sent Action List Id:' + this.action_list_id);
            
                    // this.action_list_id = changes.action_list_id.currentValue;
                    // this.getActionList(this.action_list_id);
            
            
                    
                    // }
            

      }

      
  ngOnInit() {
    console.log('Oninit: Sent Action List Id:' + this.action_list_id);
    this.search_model = new SystemLog(); // if undefined need to setup the model first.
  
    this.getSystemLogTypesWithBenchmarksStaff();
    // Get Staff Benchmark KPI Group, to auto populate the search_model
    this.getBenchmarkKpiGroup(2)

    // this.getLogsSearch(this.search_model)
    this.getBrandsComboBoxClients(this.combo_model); // gets all brands
    this.getUsers();
    this.getBrandTypes();
    this.getFormUserLevels();


    this.loadSearchDefaults(); // moved belos to a function so I can reseet the form
    // this.search_model = {
    //   // "routerLink": this.current_route,
    //   // "kpi_log_type_array": '1,2',
    //   "limit": 2500000000,
    //   "when_from": this.removeDays(7),
    //   "when_to": this.addDays(0),
    //   "created_level": '4'
      
    // }// set to empty to get all first.

// this.getLogsSearch(this.search_model);
// this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model) // load gloabl kpis with benchmarks with search

// Load the Actions related to the action list
// this.getWooPPSActionsMetaActionID('', this.action_list_id, '38' ); // Bulk Prints Only - variables do not work. - made more spefic calls below uses these



    // set a LOOP REFRESH for the action list.
                  // this.interval = setInterval(() => { 
                  //   // this.woo_orders= [];
                  //   this.getActionList(this.action_list_id);
                    
                  //  }, 130000);

    // this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.gfunc.brand_wordpress_URL + '/wp-admin/post.php?post=19351&action=edit&embedded=true');


    if(!this.action_list_id || this.action_list == '' ){


    //   this.action_list_id = +this.route.snapshot.paramMap.get('action_list_id');
    //  this.getActionList(this.action_list_id);

      // load the Actions created print lists and bulk labels
    //  this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
    //  this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);

     this.woo_page = 1; // sets the default page to load is one
     this.woo_per_page = 100;
   
     if(this.woo_page == 1){
       this.request_query = {
         // page: this.woo_page + 1,
         page: this.woo_page,
         orderby: "id",
         per_page: this.woo_per_page,
         // per_page: 10 // gets the number of rec
         }; 
     }else{
       this.request_query = {
         page: this.woo_page,
         orderby: "id",
         per_page: this.woo_per_page,
         // per_page: 10 // gets the number of rec
         }; 
     }
   







    }

             
      // Grid Options
            //   this.toolbarOptions = ['ExcelExport', 'Search'];
            //   this.initialPage = { pageSize:5 };
            //   this.filterOptions = {
            //      type: 'Menu'
            //   };
            //  // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
            //   this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
            //   this.dateFormat = 'dd/MM/yyyy hh:mm a';
            //   this.filter = { params: { format: this.dateFormat } };
            //  // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
          
          
          // end date filter options
              // End Grid Options
      }


      loadSearchDefaults(){
        // this.getSystemLogTypesWithBenchmarksStaff();


        
        let search_model = {
          include_weekends: false,
          excluded_staff_ids: defaultExcludedStaffIds(),
          // "routerLink": this.current_route,
          // "kpi_log_type_array": '1,2',
          "limit": 2500000000,
          "when_from": this.removeDays(7),
          "when_to": this.addDays(0),
          // "created_level": '4',
        'log_type_id_group': this.allLogTypesArray,

        }// set to empty to get all first.

        // this.getDateTimeDuration(this.search_model.when_from,this.search_model.when_to)

        this.search_model = search_model
        setTimeout(() => {  
this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model) // load gloabl kpis with benchmarks with search
         }, 1000);


      }



      loadSearchBenchmarkKpiGroupStaffDefaults(search_model){
        // this.getSystemLogTypesWithBenchmarksStaff();


        
        this.search_model = {
          // "routerLink": this.current_route,
          ...search_model,
        'log_type_id_group': this.allLogTypesArray,

        }// set to empty to get all first.

        // this.getDateTimeDuration(this.search_model.when_from,this.search_model.when_to)

        this.search_model = this.search_model
        setTimeout(() => {  
this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model) // load gloabl kpis with benchmarks with search
         }, 1000);


      }

      

    
    logsSearchRemoveDays(search_model, days_to_remove){

    // this.getDateTimeDuration(search_model.when_from,search_model.when_to)

      this.search_model = {
        // "routerLink": this.current_route,
        // "kpi_log_type_array": '1,2',
        ...search_model,
        "limit": 2500000000,
        "when_from": this.removeDays(days_to_remove),
        "when_to": this.addDays(0),
        'Duration': search_model.Duration,
        // 'created_level': '4', // I removed this to get all of the data, as its filtered by user anyway


      }// set to empty to get all first.
  // this.getLogsSearch(this.search_model)

  // this.search_model = new_search_model;

      this.getLogsSearchKPIBenchmarksGlobalStaff(this.search_model)
    }





// Still using will rename and rebild later
      wooPageCollectionArray(woo_page){
        // if (confirm('Please confirm your Action List has been saved first., we have to gather another 100 orders.')) {
        
        // set by loading the search_results in the grid
      // let action_list =  JSON.stringify(this.search_results_meta_array) // this was giving incorrect counts missing the first one... below fixes the issue. April 2023
      let action_list =  this.search_results_meta_array 

      // console.log('Action List: ' + action_list);
      
        this.request_query = {
          page: woo_page,
          orderby: "id",
          per_page: this.woo_per_page,
          // addition of arrays
          // include: ['1949','19349','19332','19320'], // this does not work.
          // include: [Array('19351', '19349', '19332', '19320')], // this is the correct way to send an array to wordpress!!
          include: [Array(action_list)], // this is the correct way to send an array to wordpress!!
          log_id_array: Array(action_list), // this is the correct way to send an array to wordpress!!
      

        }
        this.woo_page = woo_page; // need to set the new page
        // this.getWooOrders(this.request_query);


        // added search
        // this.request_query = this.search_results;

        this.getSystemLogsArray(this.request_query);


      // }


      }




    // request_query
    getWooOrders(request_query){
  //     if(this.grid){this.grid.showSpinner();}
  // this.orderService.listAllOrders(request_query)
  // .subscribe(response => {
  //   console.log(response);
  //   this.woo_orders = response
  //  // this.refreshGrid();
  //  if(this.grid){this.grid.hideSpinner();}
  // }, (err) => {
  //   console.log('ngx:woo:error ', err);
  // });
}


getSystemLogsArray(request_array) {
  this._demoService.getSystemLogsArray(request_array).subscribe(
     data => { this.woo_orders = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


    
      // :: Grid Functions
    
    
    // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
    clickHandler(args: ClickEventArgs): void {
      if (args.item.id === 'Click') {
    
      //  this.grid.showSpinner();
    
      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
     //  console.log(args.data.items);
     
    
    
      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        // console.log(pdfdata.results);
    
       // this.search_results = pdfdata.records; // need this if a grouping is set.
      /*   this.search_results = pdfdata;
        this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
        this.toastr.success( "Press Start To Process Que");  */
       // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
      }
    
     //  this.grid.hideSpinner();
    
    };
    
    
    toolbarClick(args: ClickEventArgs): void {
      if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
          this.grid.excelExport();
      }
    }
    rowDataBound(args:any) {
      const status = 'status';
      if (args.row.status ===  'completed') {
          // args.row.className = 'strikethrough text-primary';
          // args.row.classList.add('strikethrough');
          args.row.className = 'strikethrough text-muted';
          args.row.classList.add('below-80');

      }
    }
    
      // :: Grid Functions






      public getMyobTaxCodesLive() {
        return  this._demoService.getMyobTaxCodesLive().subscribe(
            data => { this.myob_tax_codes_live = data;
              const res = data[0];
               // https://www.concretepage.com/questions/577
               this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
               // console.log(this.arrCase);
               this.Items = data['Items'] ;
               this.sent_data = this.Items;
      
               // console.log(this.Items);
              // this.Address = this.Items['Address'];
        // return this.myobCustomers;
      
        // Map the data top the new model system
       // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
      
            },
            err => {
              // this.toastr.error('You need to login to MYOB again, Connection lost!');
             // console.error(err);
            },
            // () => console.log('done loading Trace Types')
          );
      
        }
  

        getMyobTaxCodes() {
          this._demoService.getMyobTaxCodes().subscribe(
             data => { this.myob_tax_codes = data;
              let res = data[0];
      
              // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
              // // console.log(this.arrCase);
              // this.Items = data['Items'] ;
              // this.sent_data = this.Items;
              // this.sent_data = this.myob_account_codes;
      
            },
             err => console.error(err),
             // () => console.log('done loading Trace Types')
           );
         }


         refreshGrid(){ // refresh the databutton
          // this.loadList(this.doc_id);
          // this.getMyobTaxCodesLive();
          this.getActionLists();
        //  this.grid.refresh();
        };




        createMyobTaxCodesImport(model) {

          let TaxCollectedAccount;
          let TaxPaidAccount;

          if (typeof model.TaxCollectedAccount === 'undefined' || model.TaxCollectedAccount === null ) {
            TaxCollectedAccount = null;
          }else {
            TaxCollectedAccount = model.TaxCollectedAccount.UID; // can only call if actuall exist in the array!
          };

          if (typeof model.TaxPaidAccount === 'undefined' || model.TaxPaidAccount === null ) {
            TaxPaidAccount = null;
          }else {
            TaxPaidAccount = model.TaxPaidAccount.UID;
          };
      
          let new_model = null;
          // :: Build New model
          new_model = {
            myob_tax_code_name: model.Code,
            myob_tax_code_code: model.Code,
            myob_tax_id: model.UID,
            tax_percentage: model.Rate,
            UID: model.UID,
            Code: model.Code,
            Description: model.Description,
            Type: model.Type,
            Rate: model.Rate,
            IsRateNegative: model.IsRateNegative,
            TaxCollectedAccountUID: TaxCollectedAccount,
            TaxPaidAccountUID: TaxPaidAccount,
            LastModified: model.LastModified,
            RowVersion: model.RowVersion,
            myob_array: JSON.stringify(model)
          }; // multidimentional array push
      
      // run an external function to check the vaule - does not run before function not working
      // const check_val =  this.checkForLocalMyobAccountUID(model.UID);
      // console.log('Checked Value: ' + JSON.stringify(check_val));
      
      // lookup myob accounts row with UID = local UID then filter  and count the rows. then access array for variables.
      // tslint:disable-next-line:max-line-length
      const localTaxAccountsLInkedArr = Object(this.myob_tax_codes).filter((ac) => (ac.UID === model.UID)); // filter array of already looked up myob_account_codes data
      console.log('LocalCheckCount: ' + localTaxAccountsLInkedArr.length );
      const local_account_check_length = localTaxAccountsLInkedArr.length;
      
                  if (local_account_check_length === null || local_account_check_length === 0) {
                    console.log('We need to create this one.');
                        this._demoService.createMyobTaxCodes(new_model).subscribe(
                          data => {   this.created_myob_tax_account = data; // this is the retuned json upon creation.
                            //  let res = data[0];
                        this.toastr.success('Tax Code Created Locally');
                        // return true;
                          },
                          error => {
                            console.error(error);
                          });
      
                  } else {
                    console.log('We need to UPDATE this one');
                            const local_myob_tax_code_id = localTaxAccountsLInkedArr[0].myob_tax_code_id;
                            this._demoService.updateMyobTaxCodes(new_model, local_myob_tax_code_id).subscribe(
                              data => {   this.updated_myob_tax_account = data; // this is the retuned json upon creation.
                                //  let res = data[0];
                            this.toastr.success('Tax Code Imported and Updated');
                            //  return true;
                              },
                              error => {
                                console.error(error);
                              });
      
                  }
      this.getMyobTaxCodes(); // need to refresh the loop model for next press otherwise does not know of updates to myob_account_codes
         };







         toggleShow(index) {
          // this.isShowEdit = ! this.isShowEdit;
         // if (this.isShow === index){
         // this.isShow = '';
         // }else{
         //   this.isShow = index; // sets to the array row.d
         // }
         this.isShow = index; // sets to the array row.d
         
           }
         
           toggleHide(index) {
          // this.isShowEdit = ! this.isShowEdit;
         // if (this.isShow === index){
         // this.isShow = '';
         // }else{
         //   this.isShow = index; // sets to the array row.d
         // }
         this.isShow = index; // sets to the array row.d
         
           }
         
         
         
          // MODAL
         // start of modal windows service as a template
         openModal(template: TemplateRef<any>) {
           // small upgrade to disable background click on open modal background
           const config = { backdrop: true, ignoreBackdropClick: true, class: 'blue modal-lg' };
           this.modalRef = this.modalService.show(template, config);
         }
         
         
         
         // :: Parent / Child modal test
         closeParentModel2() {
          //  alert('parent component function.');
            this.modalRef.hide();
         // now refresh the invoice items list from the new items.
             // empty your array first
             // this.invoiceItemsList.length = 0;
            //  this.workOrderItemsList.length = 0;
            //  this.getSubjectCostItems(this.subject_id);
         
         
          // this.closeParentModel.emit(); // ?shuts invoice window
          // this.refreshGrid(); // resets the grid if updated and closed.
         //  this.updateTypeClick = false; // closes the div
         };
         
         
         // :: Parent / Child modal test
         closeParentModel3() {
           //  alert('parent component function.');
             this.modalRef.hide();
          };







         getActionLists() {
          this._demoService.getActionLists().subscribe(
            data => {
              this.action_lists = data;
              this.action_lists_table = this.action_lists.slice(0, 10);
            },
            error => {
               this.toastr.error( "Sorry, we were not able to get the lists");
              //  console.error('Error Loading User!');
              // return Observable.throw(error);
            }
          );
        }


        getActionList(action_list_id){
          this._demoService.getActionList(action_list_id)
          // .pipe(
          //   this.toastr.observe({
          //     loading: '... monkey working ...',
          //     success: '🚀',
          //     error: '-'
          //  })
          //  )
          .subscribe(
            res => {
              
              this.action_list = res;
              let data = res[0];
              // this.search_results_meta = this.action_list[0].search_results_meta;
              // now need to loop through and build an object array
              this.action_list_type_id = data.action_list_type_id;

              this.search_results_meta = []; // set the empty object first.
              // this.search_results_meta_array = []; // set the empty object first.
              // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
              let newArr = JSON.parse(this.action_list[0].search_results_meta);
              // let  count_of_items = newArr.length;
              let  count_of_items = Object.keys(newArr).length;

              let  count_of_items2 = this.action_list[0].search_results_meta.length;

              console.log('Count of Meta Items: ' + count_of_items)
              console.log('Count of Meta Items2: ' + count_of_items)

            console.log('Count of search items: ' + count_of_items);
                // need to do a loop of subject_billing items (.length)
                for (let i = 0; i < count_of_items; i++) {
                let res2 = newArr[i];
                this.search_results_meta.push({
                ...newArr[i]
                });

                // set the array to just have id's to get real data.
                // this.search_results_meta_array.push({
                //   id: newArr[i].id,
                // });

                } // end for loop

                this.search_results_meta_START = this.search_results_meta; // ?? this may be causing err
                this.search_results_meta = this.search_results_meta; // ?? this may be causing errors.
              // this.search_results_meta_array = this.search_results_meta_array; // ?? this may be causing errors.

            

              this.search_results_meta_array = this.search_results_meta.map(function (system_log) {
                // return order.id
                return system_log.log_id
              });


              // This sends the array of IDS to a function to get the rsults and push to the data to
              this.wooPageCollectionArray(this.woo_page);
              
              

              // console.log('search results meta: ' + this.search_results_meta);

            // this.refreshGrid();
            this.grid3.refresh();


            },
            err => {
            this.toastr.error( "Sorry, we were not able to get the list");
              console.error(err.status);
                    }
          );
         }


         // must get the meta gain.
         getActionList_REFRESH(action_list_id){
          this._demoService.getActionList(action_list_id)
          // .pipe(
          //   this.toastr.observe({
          //     loading: '... monkey working ...',
          //     success: '🚀',
          //     error: '-'
          //  })
          //  )
          .subscribe(
            res => {
              
              this.action_list = res;
              let data = res[0];
              // this.search_results_meta = this.action_list[0].search_results_meta;
              // now need to loop through and build an object array
              this.action_list_type_id = data.action_list_type_id;

              this.search_results_meta = []; // set the empty object first.
              // this.search_results_meta_array = []; // set the empty object first.
              // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
              let newArr = JSON.parse(this.action_list[0].search_results_meta);
              // let  count_of_items = newArr.length;
              let  count_of_items = Object.keys(newArr).length;

              let  count_of_items2 = this.action_list[0].search_results_meta.length;

              console.log('Count of Meta Items: ' + count_of_items)
              console.log('Count of Meta Items2: ' + count_of_items)

            console.log('Count of search items: ' + count_of_items);
                // need to do a loop of subject_billing items (.length)
                for (let i = 0; i < count_of_items; i++) {
                let res2 = newArr[i];
                this.search_results_meta.push({
                ...newArr[i]
                });

                // set the array to just have id's to get real data.
                // this.search_results_meta_array.push({
                //   id: newArr[i].id,
                // });

                } // end for loop

              this.search_results_meta = this.search_results_meta; // ?? this may be causing errors.
              // this.search_results_meta_array = this.search_results_meta_array; // ?? this may be causing errors.

            

              this.search_results_meta_array = this.search_results_meta.map(function (system_log) {
                // return order.id
                return system_log.log_id
              });


              // This sends the array of IDS to a function to get the rsults and push to the data to
              // this.wooPageCollectionArray(this.woo_page); -- this will refresh everything. and set base. -- entire route.
              // console.log('search results meta: ' + this.search_results_meta);

            this.grid3.refresh();
            },
            err => {
            this.toastr.error( "Sorry, we were not able to get the list");
              console.error(err.status);
                    }
          );
         }
        

         deleteActionList(action_list_id){
        if (confirm('Are you sure you wish to delete this action list? ID=' + action_list_id)) {
          this._demoService.deleteActionList(action_list_id).subscribe(
            res => {this.action_list_removed = res;
              this.toastr.success( "Done, action list removed.");
           
          //  this.gfunc.globalppsDistroHubOrdersViewSkipRoute(); // load the orders page to sart the process over again
              this.refreshGrid();
            },
            err => {
            this.toastr.error( "Sorry, we were not able to delete the list");
              console.error(err.status);
              }
          );
                  }// end confirm
         }


      //    WebHookAPI_OrderLabelCreateDefaultBulk(model, order_id, doc_id){
      //     // this gets set and overridden in the route interceptor
      //     let  new_model = {
      //       'username' : 'api_user',
      //       'password' : '1234xyz',
      //       'action_list_id' : this.action_list_id,
      //       'action_list_type_id' : this.action_list_type_id,
      //       ...model, // send the entire model. - new 2023 Template System DistroHub Beta
      //       'search_results_meta_array': this.search_results_meta_array,
      //         }; // use this model for defaul testing and setup variables required and added. 

      //     this._mysqlService.WebHookAPI_OrderLabelCreateDefaultBulk(new_model, order_id, doc_id)
      //     .pipe(
      //       this.toastr.observe({
      //         loading: '... monkey working ...',
      //         success: '🚀',
      //         error: '😡'
      //      })
      //      )
      //     .subscribe(
      //       data => {  this.WebHookAPI_OrderLabelCreateDefaultBulk_response = data;
      //         // refresh the invoice:
      //         this.toastr.success('B.I.N.G.O - We created the Bulk Action for you!');
      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page
      // // load the Actions created print lists and bulk labels
      // this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
      // this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);
      //     // this.child.doSomethingChild();
      //     // this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page
      //     // Do this litte trick to reload the observable in inlcuded module in HTML page without the complications. -jist change the id and change it back and see what happens.
              

      
    
      //       },
      //       error => {
      //        // console.error('Error saving Event!');
      //         // this.toastr.error('computer says no!, sorry try again, label not created this time.');
      //         this.toastr.success('B.I.N.G.O - We created the Bulk Action for you!');
      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page
      // // load the Actions created print lists and bulk labels
      // this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
      // this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);


      //     // this.child.doSomethingChild();
      //         return console.error(error);
              
      //       }
      //      // err => console.error(err),
      //      //
      //     )};




    //       WebHookAPI_OrderPickListDefault(model, order_id, doc_id){
    //         // this gets set and overridden in the route interceptor
    //         let  new_model = {
    //           'username' : 'api_user',
    //           'password' : '1234xyz',
    //           'action_list_id' : this.action_list_id,
    //           'action_list_type_id' : this.action_list_type_id,
    //           ...model, // send the entire model. - new 2023 Template System DistroHub Beta
    //           'search_results_meta_array': this.search_results_meta_array,
    //             }; // use this model for defaul testing and setup variables required and added. 
    //             // error: '😡'
    //         this._mysqlService.WebHookAPI_OrderPickListDefault(new_model, order_id, doc_id)
    //         .pipe(
    //           this.toastr.observe({
    //             loading: '... monkey working ...',
    //             success: '🚀',
    //             error: '-'
    //          })
    //          )
    //         .subscribe(
    //           data => {  this.WebHookAPI_OrderLabelCreateDefaultBulk_response = data;
    //             // refresh the invoice:
    //             this.toastr.success('B.I.N.G.O - We created the Pick List for you!');
    //         //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page


    //             // load the Actions created print lists and bulk labels
    //  this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
    //  this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);
            
    //       // this.child.doSomethingChild();
  
    //           //  this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page
        
      
    //           },
    //           error => {
    //            // console.error('Error saving Event!');
    //       // this.child.doSomethingChild();
    //             // this.toastr.error('computer says no!, sorry try again, label not created this time.');

    //             this.toastr.success('B.I.N.G.O - We created the Pick List for you!');
    //         //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page


    //             // load the Actions created print lists and bulk labels
    //  this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
    //  this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);

    //             return console.error(error);
    //           }
    //          // err => console.error(err),
    //          //
    //         )};





// Custom WP API quiery
// getWooPPSActionsMetaActionID(request_query, action_list_id, job_type_court_id){
//   this.productSlug =  ''; // just for now so I can get the id later
//   // this.productSlug =  'per_page='+100; // just for now so I can get the id later

//   var meta_query = encodeURIComponent(JSON.stringify({
//     relation: 'AND',
//     0: {
//       key: 'action_list_id',
//       value:'2'
//     },
//     // 1: {
//     //   key: 'dayoweek',
//     //   value: 'saturday'
//     // }
//   }));

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: 5,
//     // per_page: 10 // gets the number of rec
// // action_list_type_id: 1,
// // action_list_id: 2, // actually the action list id being sent.
// // job_court_type_id: 38 // actually the action list id being sent.
// // meta_query: meta_query

//     }; 

// // proper way to search via meta data in wp query
//     // 'meta_query'  => array(
//     //   array(
//     //       'key' => 'specials',
//     //       'value' => 'these are not the specials you are looking for - Obi Wan Kenobi'
//     //   )


//   // this.params = {slug:this.productSlug}  
//   this.params = {slug: this.request_query }    
//   // this.params = {slug: request_query }            

            
//   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
//   let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wp/v2/custompost','');

//   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
//   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
//   // wc/v3/customers
//   this.http.get(wooppsactionsurl).subscribe((wc_ppsactions_data:any) => { 
  
//     // Filter results
// //           let wc_ppsactions_data_filtered = wc_ppsactions_data.map(function (officer: any) {
// //   return officer.job_type_court_id == 38 || officer.job_type_court_id == 39
// // });
     
//     // job_type_court_id == pick lists or bulk shipping


  
//   this.woo_ppsactions = wc_ppsactions_data;  
//   // this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   this.woo_ppsactions_count = this.woo_ppsactions.length; 

//   // add a filter to return spefic types -- RESULTS DO NOT WORK.
//   // if (job_type_court_id != ''){
//   //   let wc_ppsactions_data_filtered = wc_ppsactions_data.map(function (officer: any) {
//   //   return officer.ppsData[0].job_type_court_id == job_type_court_id
//   //   });

//   //   this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   //   this.woo_ppsactions_count = this.woo_ppsactions.length; 

//   // }



//   // this.product = wc_data[0];  
//   this.params = {}
//   // let productvariationurl:string = this.woocommerce.authenticateApi('GET',this.brand_wordpress_URL + '/shop/wp-json/wc/v2/products/'+this.product.id+'/variations',this.params);
//   // this.http.get(productvariationurl).subscribe((wc_pv_data:any) => {
//   //     this.productVariations = wc_pv_data;
//   });
// }




// getWooPPSActionsMetaActionIDBulkLabels(request_query, action_list_id){
//   this.productSlug =  ''; // just for now so I can get the id later
//   // this.productSlug =  'per_page='+100; // just for now so I can get the id later

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: 5,
//     // per_page: 10 // gets the number of rec
//     action_list_id : action_list_id // MUST REQURED NOW.
//     }; 


//   // this.params = {slug:this.productSlug}  
//   this.params = {slug: this.request_query }    
//   // this.params = {slug: request_query }            

            
//   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
//   let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wp/v2/ppsActionID/bulk-labels',this.request_query);

//   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
//   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
//   // wc/v3/customers
//   this.http.get(wooppsactionsurl).subscribe((wc_ppsactions_data:any) => { 


  
//   this.woo_ppsactionsBulkLabels = wc_ppsactions_data;  
//   // this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   this.woo_ppsactions_count_bulk_labels = this.woo_ppsactionsBulkLabels.length; 

//   });
// }


// getWooPPSActionsMetaActionIDPickList(request_query, action_list_id){
//   this.productSlug =  ''; // just for now so I can get the id later
//   // this.productSlug =  'per_page='+100; // just for now so I can get the id later

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: 5,
//     // per_page: 10 // gets the number of rec
// action_list_id : action_list_id // MUST REQURED NOW.
//     }; 


//   // this.params = {slug:this.productSlug}  
//   this.params = {slug: this.request_query }    
//   // this.params = {slug: request_query }            

            
//   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
//   let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wp/v2/ppsActionID/picklist',this.request_query);

//   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
//   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
//   // wc/v3/customers
//   this.http.get(wooppsactionsurl).subscribe((wc_ppsactions_data:any) => { 
  
//   this.woo_ppsactionsPickList = wc_ppsactions_data;  
//   // this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   this.woo_ppsactions_count_picklist = this.woo_ppsactionsPickList.length; 

//   });
// }



// grid search buttons
searchGridColStatus(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  console.log('Packing');
  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}



// Log Filter
searchGridColLogTypeName(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // console.log('Packing');
  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['log_type_name'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid2.refresh();
}



searchGridColCreatedVia(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['created_via'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}


searchGridRemaining(string) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: 'processing', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}

searchGridColTotalAbove(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['total'], operator: 'greaterThanOrEqual', key: '65', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}



searchGridMail(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'lessThanOrEqual ', key: '.01', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}


searchGridCP(name) {
  this.searchOptions = {  };
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'greaterThanOrEqual ', key: '1', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}

clearSearchGrid() {
  this.grid2.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}



getSystemLogTypesWithBenchmarksStaff() {
  this._demoService.getSystemLogTypesWithBenchmarksStaff().subscribe(
     data2 => { this.system_log_types = data2;
      // console.log(data2);
let res  = data2

this.log_types_selected_kpi_array = []

let count_of_items = Object.keys(this.system_log_types).length;


              //  // Populate availableLogTypes for the Dual ListBox
              //  this.availableLogTypes = this.system_log_types.map(log => ({
              //   id: log.log_type_id,
              //   name: log.log_type_name
              // }));


              //         // Map to an array of objects with 'text' and 'value'
              //         this.log_type_id_group_staff = this.system_log_types.map(logType => ({
              //           log_type_name: logType.log_type_name,
              //           log_type_id: logType.log_type_id
              //         }));


              //               // Create an object with log_type_id as keys and a placeholder value (e.g., true or an empty string)
              //       this.log_types_selected_kpi_object = this.system_log_types.reduce((acc, logType) => {
              //         acc[logType.log_type_id] = true; // or you can use an empty string: acc[logType.log_type_id] = '';
              //         return acc;
              //       }, {});

  

for (let i = 0; i < count_of_items; i++) {
// if(
// this.system_log_types[i].log_type_id == 5 ||
// this.system_log_types[i].log_type_id == 30 ||
// this.system_log_types[i].log_type_id == 6 ||
// this.system_log_types[i].log_type_id == 13 


// ){}// end if

  this.log_types_selected_kpi_array.push({
    ...this.system_log_types[i]
  })





}

   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }



// Display a modal window informing that there are no attachments on send.

onOpenDialogSendComms = function(event: any, model): void {

  // if(this.allAttachments.length <= 0 && this.cancel_clicked != 1){ }// end if.

  this.DialogObj = DialogUtility.confirm({
    title: '<i class="fa fa-magic text-success font-bold pull-left"></i> Let us Setup some things are you ready....! ',
    // tslint:disable-next-line:max-line-length
    content: '<i class="fa fa-check fa-2x text-success font-bold pull-left"></i> <b> By pressing "Continue" ... we will..</p><ol><li>Set Status of Order - Packing</li><li>Automatically Open a New window, Loading the Order in Woo</li><li>And Automatically route to the portal view of this order, ready to pack.</li></ol> ',
    okButton: {  text: '<i class="fa fa-check text-success font-bold pull-left"></i> Continue, and do your stuff.', click: this.okClickSaveSubject.bind(this, model) },
    cancelButton: {  text: '<i class="fa fa-times text-danger font-bold pull-left"></i> Cancel for now', click: this.cancelClickSaveSubject.bind(this, model) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});

 
}

public okClickSaveSubject(model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
// this.clientJobSubmission(this.job_id);
// this.cancel_clicked = 0;
// this.click_continue = 1;
// this.sendAgentCommunicationEmail(model);


// this.WebHookAPI_PickPackSend_WC_OrderPageUpdate(model, model.id, '')
           

// This function sets the status to packing... need to update name functions and create a more universal function... push stutus as var.
// this.WebHookAPI_PickPackSend_WC_PageUpdateStatus(model, model.id, '', 'packing') // sets new status to packing.
            // this.openLink_WP_Order_Edit(model.id)
            // this.gfunc.globalppsDistroHubOrderViewSkipRoute(model.id); // now refresh the page

this.DialogObj.hide();
}

public cancelClickSaveSubject(model): void {
   // alert('you clicked Cancel button');
  //  this.cancel_clicked = 1;
  //  this.click_continue = 0;
   this.DialogObj.hide();
}


// Custom page API using now - qpril 2022
// WebHookAPI_PickPackSend_WC_OrderPageUpdate(model, order_id, doc_id){
//   // if (confirm('Please confirm this will change the status of this order to picking...')) {
//   // this gets set and overridden in the route interceptor
//   let  new_model = {
//     'username' : 'api_user',
//     'password' : '1234xyz',
//     // 'action_list_id' : this.action_list_id,
//     // 'action_list_type_id' : this.action_list_type_id,
//     ...model, // send the entire model. - new 2023 Template System DistroHub Beta
//     // 'search_results_meta_array': this.search_results_meta_array,
//     // April 2024 send post data update from form model.
//     'model' : JSON.stringify(model),
//       }; // use this model for defaul testing and setup variables required and added. 
//       // error: '😡'
//   this._mysqlService.WebHookAPI_PickPackSend_WC_OrderPageUpdate(new_model, order_id, doc_id)
//   .pipe(
//     this.toastr.observe({
//       loading: '... monkey working ...',
//       success: '🚀',
//       error: '-'
//    })
//    )
//   .subscribe(
//     data => {  this.WebHookAPI_PickPackSend_WC_page_update_response = data;
//       // refresh the invoice:
//       this.toastr.success('...Order Status Updated.');
     
//       // after update d
//       this.openLink_WP_Order_Edit(model.id)
//       // this.getActionList(this.action_list_id);
//      this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

//     //  this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page

//     },
//     error => {
//      // console.error('Error saving Event!');

//       // this.toastr.error('computer says no!, sorry try again, page not updated.');
//       this.openLink_WP_Order_Edit(model.id)
//       // this.getActionList(this.action_list_id);
//      this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page
//       return console.error(error);
//     }
//    // err => console.error(err),
//    //
//   )
// // };//end if.

// } 



// WebHookAPI_PickPackSend_WC_PageUpdateStatus(model, order_id, doc_id, new_status){
//   if (confirm('Please confirm this will change the status of this order to '+ new_status +'...')) {
//   // this gets set and overridden in the route interceptor
//   let  new_model = {
//     'username' : 'api_user',
//     'password' : '1234xyz',
//     // 'action_list_id' : this.action_list_id,
//     // 'action_list_type_id' : this.action_list_type_id,
//     ...model, // send the entire model. - new 2023 Template System DistroHub Beta
//     // 'search_results_meta_array': this.search_results_meta_array,
//     // April 2024 send post data update from form model.
//     'model' : JSON.stringify(model),
//       }; // use this model for defaul testing and setup variables required and added. 
//       // error: '😡'
//   this._mysqlService.WebHookAPI_PickPackSend_WC_PageUpdateStatus(new_model, order_id, doc_id, new_status)
//   .pipe(
//     this.toastr.observe({
//       loading: '... monkey working ...',
//       success: '🚀',
//       error: '-'
//    })
//    )
//   .subscribe(
//     data => {  this.WebHookAPI_PickPackSend_WC_page_update_status_response = data;
//       // refresh the invoice:
//       this.toastr.success('... Status Updated.');
     
//       // after update d
//     //   this.openLink_WP_Order_Edit(model.id)
//     //   // this.getActionList(this.action_list_id);
//     //  this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

//     //  this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page

//     },
//     error => {
//      // console.error('Error saving Event!');

//       this.toastr.error('computer says no!, sorry try again, page not updated.');
//       return console.error(error);
//     }
//    // err => console.error(err),
//    //
//   )
// };//end if.

// } 




openLink_WP_Order_Edit(id){
  // let link = this.gfunc.brand_wordpress_URL + '/wp-admin/post.php?post=' + id + '&action=edit';
  // window.open(link);
}










getBrandsComboBoxClients(combo_model) {
  // this.combo_model.brand_id = 2;
 this._demoService.getBrands().subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


// getBrandsComboBoxClients(combo_model) {
//   // this.combo_model.brand_id = 2;
//  this._demoService.getBrandsComboBox(combo_model).subscribe(
//     data => { this.brands_client = data; },
//     err => console.error(err),
//     // () => console.log('done loading Trace Types')
//   );
// }

getBrandsComboBoxAgents(combo_model) {
 this.combo_model.brand_id = 3;
this._demoService.getBrandsComboBox(combo_model).subscribe(
   data => { this.brands_agent = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}




getUsers() {
this._demoService.getUsers().subscribe(
   data => { 
    this.users = data;

    // TODO
    // simple loadash to map only staff members.
    let count_of_items = Object.keys(this.users).length;

this.users_staff = [];

    for (let i = 0; i < count_of_items; i++) {

 if(this.users[i].access_level <= 4){
  this.users_staff.push({
    ...this.users[i]
  })
 }
 this.users_staff = this.users_staff;
}
// The users API may return string IDs. Syncfusion chip removal compares ID types strictly.
this.staffExclusionOptions = this.users_staff.map(staff => ({ user_id: Number(staff.user_id), user_full_name: staff.user_full_name }));



    },
   err => console.error(err),
   () => console.log('done loading users')
 );
}


  // Functions
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }

   getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }


   getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }


   updateSavedFileName() {
    // const fromDate = this.datepipe.transform(this.search_model.when_from, 'dd_MMM_yyyy');
    // const toDate = this.datepipe.transform(this.search_model.when_to, 'dd_MMM_yyyy');
    const fromDate = this.datepipe.transform(this.search_model.when_from, 'dd_MMM_yyyy_HHmmss', '+1000');
    const toDate = this.datepipe.transform(this.search_model.when_to, 'dd_MMM_yyyy_HHmmss', '+1000');

    
    // Check if a specific user is selected
    let userPart = 'all';
    if (this.search_model.created_by) {
        const user = this.getUserById(this.search_model.created_by); // Replace with your method to get the user
        if (user) {
            userPart = `${user.first_name}_${user.surname}`;
        }
    }

    this.search_model.saved_file_name = `staff_${userPart}_metrics_${fromDate}_to_${toDate}`;
}

      getUserById(userId: number) {
      return this.users?.find(user => user.user_id === userId);
      }

   // staff perspective
   public getLogsSearchKPIBenchmarksGlobalStaff(search_model) {
    const staffGeneration = ++this.staffFilterGeneration;
    const requestedCalendar = { include_weekends: search_model.include_weekends };
    const requestedExclusions = { excluded_staff_ids: [...(search_model.excluded_staff_ids || [])] };
    this.staffExclusionWarning = ''; this.staffBenchmarkWarning = '';
    this.staffReportCalendar = null; this.staffCalendarWarning = '';





// clear the variantels


    this.syncCalendarSelection();
    this.getDateTimeDuration(search_model.when_from,search_model.when_to)
    this.weightedSearch = JSON.parse(JSON.stringify(search_model));

    // this.getLogsSearch(search_model); // search both queries

    // this.search_model.saved_file_name = 'staff_all_' + this.gfunc.safeDateTimeForFileName + '_';
    this.updateSavedFileName();
    
    // this.logs_search_kPI_benchmarks_global = [];
    // this.count_logs_search_kPI_benchmarks_global = null
        // this.created_by_count_array_data = null; // ckear
        // this.logs_search_kPI_benchmarks_global_GRID = null; // clear
    

        
// normalise the datems -- before the search.
    // const when_from = new Date(search_model.when_from).toISOString(); // '2024-11-22T00:27:00Z'
    // const when_to = new Date(search_model.when_to).toISOString();   // '2024-11-23T00:27:00Z'
    // search_model.when_from = when_from;
    // search_model.when_to = when_to;

    this.logs_search_kPI_benchmarks_global = [];

    this._demoService.fetchSystemLogSearchActivityStaff2(search_model)
    .pipe(
      this.toastr.observe({
        loading: 'Checking Global Metrics...',
        success: '🚀',
        error: '...😡...'
     })
     )
    .subscribe(
      (res) => {
        if (staffGeneration !== this.staffFilterGeneration) { return; }
        this.staffReportCalendar = Object.values(res[1] || {}).find((row: any) => row?.reporting_calendar)?.['reporting_calendar'] || null;
        if (Object.keys(res[1] || {}).length && !staffCalendarMatches(this.staffReportCalendar, requestedCalendar)) {
          this.staffCalendarWarning = STAFF_CALENDAR_UPDATE_MESSAGE + ' The legacy charts below still show their original calendar calculations.';
        }
        const exclusionRow = [...Object.values(res[1] || {}), ...Object.values(res[0] || {})].find((row: any) => row?.staff_exclusions);
        if (!staffExclusionsMatch(exclusionRow || {}, requestedExclusions)) {
          this.staffExclusionWarning = STAFF_EXCLUSIONS_UPDATE_MESSAGE + ' The legacy results below have not applied the requested staff exclusions.';
        }
        const benchmarkRow: any = [...Object.values(res[1] || {}), ...Object.values(res[0] || {})].find((row: any) => row?.benchmark_policy);
        if (!benchmarkRow && (Object.keys(res[1] || {}).length || Object.keys(res[0] || {}).length)) {
          this.staffBenchmarkWarning = STAFF_ACTIVE_BENCHMARKS_UPDATE_MESSAGE + ' These legacy results may still use inactive benchmarks.';
        } else if (benchmarkRow?.benchmark_configuration_errors?.length) {
          this.staffBenchmarkWarning = 'KPI comparisons omit actions with conflicting active benchmarks: ' + benchmarkRow.benchmark_configuration_errors.map(issue => issue.name + ' (records ' + issue.benchmark_ids.join(', ') + ')').join('; ') + '. Keep one active staff benchmark per action.';
        }
        this.logs_search_kPI_benchmarks_global = res;
      
        //0: the first Recorst is the search metric table for current search model results
        //1: is the resutls for the created_by_user_count array

        // If I build a merged return resutls I need to fix the counts
        // this.count_logs_search_kPI_benchmarks_global = Object.keys(this.logs_search_kPI_benchmarks_global[0]).length;
        this.count_logs_search_kPI_benchmarks_global = Object.keys(this.logs_search_kPI_benchmarks_global[1]).length;
        // this.count_logs_search_kPI_benchmarks_global = 15;
      
        this.logs_search_kPI_benchmarks_global_GRID = [];
        this.logs_search_kPI_benchmarks_global_GRID_count = null;

        this.created_by_count_array_data = []
        this.all_items_count_array_data = this.logs_search_kPI_benchmarks_global[2] // all times 
        this.all_items_count_array_data_count = this.all_items_count_array_data.length;

        for(let i=0;i < this.count_logs_search_kPI_benchmarks_global; i++) {
          let res = this.logs_search_kPI_benchmarks_global[i];

         
         // Flattern the return s grid can read the data
         if(this.logs_search_kPI_benchmarks_global[0][i]){
          this.logs_search_kPI_benchmarks_global_GRID.push({
            ...this.logs_search_kPI_benchmarks_global[0][i]
          })
        }

          this.logs_search_kPI_benchmarks_global_GRID_count = this.logs_search_kPI_benchmarks_global_GRID.length;


       
        // Flattern the return s grid can read the -- user_created_data
        // if(this.logs_search_kPI_benchmarks_global[1][i].user_id){ // removed so I could show empties
  
  
  
        // commmneted out for many selection????? 
  //   if(this.logs_search_kPI_benchmarks_global[1][i]){ // removed so I could show empties

  //     this.created_by_count_array_data.push({
  //       ...this.logs_search_kPI_benchmarks_global[1][i]
  //     })
  //  } 


      


      // Flattern the return s grid can read the -- ALL ITEMLS // as default returned resulsts... all log items
      // uncomment to see all results...
          // if(this.logs_search_kPI_benchmarks_global[2]){
          //   this.all_items_count_array_data.push({
          //     ...this.logs_search_kPI_benchmarks_global[2][i]
          //   })
          // }

        }
       
        this.dateInfo = null; // reset the list
        // this.intentifyFirstAndLastDates(); // get the all logs start and finish dates as recores.




const selectedIds = this.search_model.created_by_group;

// Loop through each item in logs_search_kPI_benchmarks_global[1] and apply the filter
for (let i = 0; i < this.count_logs_search_kPI_benchmarks_global; i++) {
  // Check if the item exists and if its user_id is in selectedIds
  const item = this.logs_search_kPI_benchmarks_global[1][i];
  if (item && (!selectedIds || selectedIds.includes(item.user_id))) {
    // Push the item to created_by_count_array_data if it matches the selected IDs
    this.created_by_count_array_data.push({ ...item });
  }
}





      
              },
      (err) => {console.error(err.status)}
    );
  } /* */



  intentifyFirstAndLastDates()  {
    if (this.all_items_count_array_data && this.all_items_count_array_data.length > 0) {
      // Sort the array by created_date in ascending order (earliest date first)
      this.all_items_count_array_data = [...this.all_items_count_array_data].sort((a, b) => {
        const comparison = this.legalDate.compareAudit(a.created_date, b.created_date);
        return comparison ?? 0;
      });
  
      // Set the first and last records
      const firstRecord = this.all_items_count_array_data[0];
      const lastRecord = this.all_items_count_array_data[this.all_items_count_array_data.length - 1];
  
      // Optionally set variables or an object with the first and last records
      this.dateInfo = {
        firstRecord,
        lastRecord,
      };
  
      // Log results for debugging
      console.log('First Record:', firstRecord);
      console.log('Last Record:', lastRecord);
      console.log('Ordered List (Earliest First):', this.all_items_count_array_data);
    } else {
      console.error('Data is empty or undefined');
    }
  }




  public getLogsSearch(search_model) {

    this.getDateTimeDuration(search_model.when_from,search_model.when_to)
    
    this.logs_search = [];
    this._demoService.fetchSystemLogSearch(search_model)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: '🚀',
        error: '...😡...'
     })
     )
    .subscribe(
      (res) => {
        this.logs_search = res;
        this.woo_orders = this.logs_search; // changes the grid data
       
       
       
       
       
       // Lets Build some KPI Data Models.
       let  count_of_log_items = Object.keys(this.logs_search).length;
       this.count_logs_search = Object.keys(this.logs_search).length;


                    //  this.log_types_kpi_array = []
                    //  this.log_type_kpi_5_array = []
                    //  // Each type has an array and a count...  ---- Send this information back in data...
                    //  this.log_type_kpi_array_30 = []
                    //  this.count_log_type_kpi_array_30 = 0;

                    //  // create job
                    //  this.log_type_kpi_array_6 = []
                    //  this.count_log_type_kpi_array_6 = 0;
                    // // job_update
                    //  this.log_type_kpi_array_13 = []
                    //  this.count_log_type_kpi_array_13 = 0;


                    //  // For each of type /// -- KPI Setup Arrays 

                    //  for(let i=0;i < count_of_log_items; i++) {
                    //   let res = this.logs_search[i];


                    //   // Log Type User logind
                    //   if(res.log_type_id == 5){
                    //     this.log_type_kpi_5_array.push({
                    //       ...res,
                    //     })
                    //   this.log_type_kpi_5_count = this.log_type_kpi_5_array.length;
                    //   this.count_log_type_kpi_array_5 = this.log_type_kpi_5_array.length;

                    //   }

                    

                    // if(res.log_type_id == 1){
                    //            // For each log type I need to Build A Metrics Array
                    //          this.log_types_kpi_array.push({
                    //            ...res,
                    //            "7_day_metric_system": 70,
                    //            "7_day_metric_staff_user" : 10,
                    //            "7_day_metric_agent_user" : 5,
                    //            "7_day_metric_client_user" : 5,
                    //            "7_day_metric_admin_user" : 1,
                    //            "count" : this.count_logs_search,
                              
                    //          })

                    //          this.count_log_type_kpi_1 = this.log_types_kpi_array.length;

                    //         }


                    //         // user_logout
                    //         if(res.log_type_id == 30){
                    //           // For each log type I need to Build A Metrics Array
                    //         this.log_type_kpi_array_30.push({
                    //           ...this.logs_search[i],
                    //           "7_day_metric_system": 70,
                    //           "7_day_metric_staff_user" : 10,
                    //           "7_day_metric_agent_user" : 5,
                    //           "7_day_metric_client_user" : 5,
                    //           "7_day_metric_admin_user" : 1,
                    //         })

                    //            this.count_log_type_kpi_array_30 = this.log_type_kpi_array_30.length;

                    //        }


                    //         // create_job
                    //         if(res.log_type_id == 6){
                    //         // For each log type I need to Build A Metrics Array
                    //       this.log_type_kpi_array_6.push({
                    //         ...this.logs_search[i]
                    //       })

                    //           this.count_log_type_kpi_array_6 = this.log_type_kpi_array_6.length;

                    //       }


                    //       // create_job_update
                    //       if(res.log_type_id == 13){
                    //         // For each log type I need to Build A Metrics Array
                    //       this.log_type_kpi_array_13.push({
                    //         ...this.logs_search[i]
                    //       })

                    //           this.count_log_type_kpi_array_13 = this.log_type_kpi_array_13.length;

                    //       }







                    //       } // end loop
                    
                    
                    


                    //  // Idea is to loop through the app route types and get the benchmarks and current counts and push to a row, with clculations already generated.
                    //       // Build a Sample table of Data from All Route Types.
                    //  this.log_type_kpi_array_metric_table = []
                    //  // for each route type we need the count, //

                    //  let count_system_log_types =  Object.keys(this.log_types_selected_kpi_array).length;
                

                    //  for(let i=0;i < count_system_log_types; i++) {

                    //   let count = 0;
                    //   // let benchmark = 2; // per day // this needs to come from the log type itslef.
                    //   let benchmark = this.log_types_selected_kpi_array[i].unit_per_day; // per day // this needs to come from the log type itslef.
                    //   let difference = 0
                    //   let rating = '';
                    //   let rating_score = 0;


                    //   /// Need to add the duration of days to the seardh model and show un UI
                      
                    //   // Duration in Days counts... ms to days...
                    //   let duration_in_days = this.daysInMilliseconds(this.search_model.Duration);
                    //   let count_duration = 0;
                    //   let benchmark_duration = benchmark * duration_in_days ; // benchmark based on day duration of selction/  /7 as the orignal benmarks are for 7 days.
                    //   let difference_duration = 0;
                    //   let rating_score_duration = 0;

                    //   // Counts are set from the pushed functions and lengths of each array above --- Need to do this for all Key API that has been listed.
                    //   if(this.log_types_selected_kpi_array[i].log_type_id == 5){ 
                    //     benchmark = this.log_types_selected_kpi_array[i].unit_per_day;
                    //     benchmark_duration = benchmark * duration_in_days ; // benchmark based on day duration of selction/  /7 as the orignal benmarks are for 7 days.
                    //     count =this.count_log_type_kpi_array_5
                    //     difference = (benchmark - count)
                    //     if(difference < 0){
                    //       rating = "above"
                    //       rating_score = 1;
                    //     }
                    //     if(difference > 0){
                    //       rating = "below"
                    //       rating_score = -1;

                    //     }
                    //     count_duration =this.count_log_type_kpi_array_5
                    //     difference_duration = (benchmark_duration - count_duration)
                    //     if(difference_duration < 0){
                    //       rating_score_duration = 1;
                    //     }
                    //     if(difference_duration > 0){
                    //       rating_score_duration = -1;
                    //     }

                    //   }
                    //   if(this.log_types_selected_kpi_array[i].log_type_id == 30){ 
                    //     benchmark = this.log_types_selected_kpi_array[i].unit_per_day;
                    //     benchmark_duration = benchmark * duration_in_days ; // benchmark based on day duration of selction/  /7 as the orignal benmarks are for 7 days.
                    //     count =this.count_log_type_kpi_array_30
                    //     difference = (benchmark - count)
                    //     if(difference < 0){
                    //       rating = "above"
                    //       rating_score = 1;
                    //     }
                    //     if(difference > 0){
                    //       rating = "below"
                    //       rating_score = -1;

                    //     }
                    //     count_duration = this.count_log_type_kpi_array_30
                    //     difference_duration = (benchmark_duration - count_duration)
                    //     if(difference_duration < 0){
                    //       rating_score_duration = 1;
                    //     }
                    //     if(difference_duration > 0){
                    //       rating_score_duration = -1;
                    //     }
                    //    }

                    //    if(this.log_types_selected_kpi_array[i].log_type_id == 6){ 
                    //     benchmark = this.log_types_selected_kpi_array[i].unit_per_day;
                    //     benchmark_duration = benchmark * duration_in_days ; // benchmark based on day duration of selction/  /7 as the orignal benmarks are for 7 days.
                    //     count =this.count_log_type_kpi_array_6
                    //     difference = (benchmark - count)
                    //     if(difference < 0){
                    //       rating = "above"
                    //       rating_score = 1;
                    //     }
                    //     if(difference > 0){
                    //       rating = "below"
                    //       rating_score = -1;

                    //     }
                    //     count_duration = this.count_log_type_kpi_array_6
                    //     difference_duration = (benchmark_duration - count_duration)
                    //     if(difference_duration < 0){
                    //       rating_score_duration = 1;
                    //     }
                    //     if(difference_duration > 0){
                    //       rating_score_duration = -1;
                    //     }
                    //    }

                    //    if(this.log_types_selected_kpi_array[i].log_type_id == 13){ 
                    //     benchmark = this.log_types_selected_kpi_array[i].unit_per_day;
                    //     benchmark_duration = benchmark * duration_in_days ; // benchmark based on day duration of selction/  /7 as the orignal benmarks are for 7 days.
                    //     count =this.count_log_type_kpi_array_13
                    //     difference = (benchmark - count)
                    //     if(difference < 0){
                    //       rating = "above"
                    //       rating_score = 1;
                    //     }
                    //     if(difference > 0){
                    //       rating = "below"
                    //       rating_score = -1;

                    //     }
                    //     count_duration = this.count_log_type_kpi_array_13
                    //     difference_duration = (benchmark_duration - count_duration)
                    //     if(difference_duration < 0){
                    //       rating_score_duration = 1;
                    //     }
                    //     if(difference_duration > 0){
                    //       rating_score_duration = -1;
                    //     }
                    //    }



                      

                    //         this.log_type_kpi_array_metric_table.push({
                    //           ...this.log_types_selected_kpi_array[i],
                    //           "count": count,
                    //           "benchmark": benchmark,
                    //           "difference": difference,
                    //           "rating": rating,
                    //           "rating_score": rating_score,
                    //           "count_duration": count_duration,
                    //           "benchmark_duration": benchmark_duration,
                    //           "difference_duration": difference_duration,
                    //           "rating_score_duration": rating_score_duration,
                    //         })
                        
                    //       }

                    
                    
                    
                    
                    
                    
                    
                    
       
       
       
       
       
        this.grid2.refresh()
              },
      (err) => console.error(err.status)
    );
  } /* */




  daysInMilliseconds(ms){
    let aDayInMs = 24 * 60 * 60 * 1000
    return  ms / aDayInMs
 }


  public getLogsSearch_Meta(search_model) {
    
    
    // Need to reset the search results and reload the orgilab meta first
    // this.getActionList_REFRESH(this.action_list_id); // clears and reloads the list to search again.
// this.search_results_meta = this.search_results_meta_START;


    this.logs_search = [];
    // CreatedBy Filter
  this.logs_search = DataUtil.parse.parseJson(search_model); // works for meta pass - not direct orders via mysql?
  // this.graph_data = new DataManager(this.search_results as JSON[]).executeLocal(new Query()); // Sets the grid data for the graphs //.take(100)
  // var group = _.groupBy(this.logs_search, 'log_type_name')


      //   /// THIS CURRENTLY DOES NOTHING... if statemetn
      //  if(this.search_results_meta != '[]'){ // if form values
  let filtered_array = _.filter(this.search_results_meta_START, 
    // { 'created_by': search_model.created_by, 'active': true }
    { 'created_by': search_model.created_by }
);
// Printing the output 
// console.log(filtered_array);
 
this.search_results_meta = filtered_array;
this.grid3.refresh();
 

      // }else{
      //   this.search_results_meta = this.search_results_meta_START; // refresh
      //   this.grid3.refresh();
      // } // end if search model.



// Need to apply filters on the data and return using javascript typescript or loadash

    // this._demoService.fetchSystemLogSearch(search_model)
    // .pipe(
    //   this.toastr.observe({
    //     loading: 'Checking...',
    //     success: '🚀',
    //     error: '...😡...'
    //  })
    //  )
    // .subscribe(
    //   (res) => (
    //     this.logs_search = res,
    //     this.woo_orders = this.logs_search, // changes the grid data
    //     this.grid2.refresh()
    //     ),
    //   (err) => console.error(err.status)
    // );
  } /* */





// Get Date Duration Between Two Dates
getDateTimeDuration(a,b){
// const firstDate: Date = new Date('2023-12-21');
// // Current Date
// const secondDate: Date = new Date();


this.search_model.Duration = 0;// set to null


const firstDate: Date = b;
const secondDate: Date = a;


// Time Difference in Milliseconds
const milliDiff: number = firstDate.getTime()
    - secondDate.getTime();

// Converting time into hh:mm:ss format

// Total number of seconds in the difference
const totalSeconds = Math.floor(milliDiff / 1000);

// Total number of minutes in the difference
const totalMinutes = Math.floor(totalSeconds / 60);

// Total number of hours in the difference
const totalHours = Math.floor(totalMinutes / 60);

// Getting the number of seconds left in one minute
const remSeconds = totalSeconds % 60;

// Getting the number of minutes left in one hour
const remMinutes = totalMinutes % 60;

console.log(`${totalHours}:${remMinutes}:${remSeconds}`);

this.duration_seconds = totalSeconds;
this.duration_minutes = totalMinutes;
this.duration_hours = totalHours;

// now run the function to build the duration model
this.toastr.info('Re calculating Item Duration')

// set back the main variables
// this.model.Duration = milliDiff;
// this.model.StartTime = a;
// this.model.EndTime = b;

this.search_model.Duration = milliDiff;
this.search_model.when_from = a
this.search_model.when_to = b




return milliDiff; // returns the difference in milliseconds.
}


getTimeFromNow(a, b){

const firstDate: Date = b;
const secondDate: Date = a;

return moment(b, 'YYYYMMDD').fromNow()

}




  // From Now.
  addDays(days : number): Date{
    let futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + days);
    return futureDate;
    }
    
    
    removeDays(days : number): Date{
    let futureDate = new Date();
    futureDate.setDate(futureDate.getDate() - days);
    return futureDate;
    }




    getDurationFromMillisenconds(t) {
      let year,
          month,
          day,
          hour,
          minute,
          second;
    
      second = Math.floor(t / 1000);
      minute = Math.floor(second / 60);
      second = second % 60;
      hour = Math.floor(minute / 60);
      minute = minute % 60;
      day = Math.floor(hour / 24);
      hour = hour % 24;
      month = Math.floor(day / 30);
      day = day % 30;
      year = Math.floor(month / 12);
      month = month % 12;
    
      this.search_model_duration_array = []; // empty first
    
      this.search_model_duration_array.push({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        });
        this.search_model_duration_array = this.search_model_duration_array;
    
    
      // return { year, month, day, hour, minute, second };
      return year + 'yrs ' +  month + ' months ' + day + ' days ' + hour + ' hrs ' + minute + ' mins ' + second + ' sec ' ;
    
    
      // rewrite this scipt to return a model and oject so I can choose to dispaly or not and make a better UI system with the data
    
    
    
    }




    getBenchmarkKpiGroup(benchmark_kpi_group_id) {
      this._demoService.getBenchmarkKpiGroup(benchmark_kpi_group_id).subscribe(
         data => { this.benchmark_kpi_group = data;
    
          let res = data[0]
          // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
          this.allLogTypesArray = JSON.parse(this.benchmark_kpi_group[0].log_types_array);
          // // Lookup the Automations
    
          let new_model = {
            log_types_array: JSON.parse(this.benchmark_kpi_group[0].log_types_array)
          }
          // this.getSystemAutomationsArray(new_model);
    
          this.getBenchmarkKpiGroupLogTypesArray(new_model)
    
        
        },
         err => console.error(err),
         () => console.log('System Log Type')
       );
     }



     
 getBenchmarkKpiGroupLogTypesArray(request_array) {
  this._demoService.getBenchmarkKpiGroupLogTypesArray(request_array).subscribe(
     data => { 
      // this.system_log_type_automations = data;
      this.benchmark_kpi_group_log_type_array = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 saveStaffMetricsData(search_model) {
  if (confirm('Save Metrics as a Footprint?')) {

  const dataToSave = {
      data: this.logs_search_kPI_benchmarks_global,         // Loaded data
      search_model: search_model,  // Search model
      weighted_work: this.weightedWork?.snapshot(search_model) || { version: 1, status: 'unavailable', reason: 'Weighted work was not loaded.' },
      staff_achievement: this.staffAchievement?.snapshot(search_model) || { version: 1, status: 'unavailable', reason: 'Staff achievement was not loaded.' },
      saved_file_name: search_model.saved_file_name
  };
  this._demoService.saveStaffMetricsData(dataToSave).subscribe(
      response => (console.log('Data saved successfully:', response),
    this.toastr.success('Saved.')
    ),
      error => console.error('Error saving data:', error)
  );
}
 }



}
